import {Component, Input, OnInit} from '@angular/core';
import {ErrorAlert} from "../../models/error-alert";

@Component({
  selector: 'error-alert-block',
  templateUrl: './error-alert-block.component.html',
  styleUrls: ['./error-alert-block.component.scss']
})
export class ErrorAlertBlockComponent implements OnInit {
  @Input() error: ErrorAlert = new ErrorAlert();

  constructor() { }

  ngOnInit() {
  }
}
